import { Injectable } from '@angular/core';
import {TrackEventGQL, TrackEventMutationVariables} from '../../../generated/graphql';

@Injectable({ providedIn: 'root' })
export class BackendTrackingService {
  constructor(private trackEventGQL: TrackEventGQL) {
  }
  public async trackEvent(event: TrackEventMutationVariables): Promise<void> {
    await this.trackEventGQL.mutate(event).toPromise()
  }
}
